import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';

import { recycleIcon } from '@ld.consumer-portal/data-uri';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

export type PaperlessPromptAction = 'go_paperless' | 'remind_later' | 'no_thanks';

@Component({
  selector: 'ld-paperless-prompt-modal',
  imports: [BaseModalComponent, TranslocoDirective, MatIconModule, MatProgressSpinnerModule, NgOptimizedImage],
  templateUrl: './paperless-prompt-modal.component.html',
  styleUrl: './paperless-prompt-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaperlessPromptModalComponent {
  isLoading = input<boolean>(false);

  goPaperless = output<void>();

  remindLater = output<void>();

  noThanks = output<void>();

  close = output<void>();

  protected readonly recycleIcon = recycleIcon;

  protected readonly loadingAction = signal<PaperlessPromptAction | null>(null);

  protected onGoPaperless(): void {
    if (this.isLoading() || this.loadingAction()) return;
    this.loadingAction.set('go_paperless');
    this.goPaperless.emit();
  }

  protected onRemindLater(): void {
    if (this.isLoading() || this.loadingAction()) return;
    this.loadingAction.set('remind_later');
    this.remindLater.emit();
  }

  protected onNoThanks(): void {
    if (this.isLoading() || this.loadingAction()) return;
    this.loadingAction.set('no_thanks');
    this.noThanks.emit();
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget && !this.isLoading() && !this.loadingAction()) {
      this.close.emit();
    }
  }

  resetLoading(): void {
    this.loadingAction.set(null);
  }
}
